/* eslint-disable */
import { percentageDifference, percentageDifferenceAbs } from "utils/helper";
import "./athleteOverviewSummaryCard.scss";
import OverivewRadarChart from "./OverviewRadarChart/OverviewRadarChart";
import OverviewSummaryCard from "./OverviewSummaryCards/OverviewSummaryCard";

function calculateZScore(value, array) {
  array = array?.filter((item) => typeof item === "number" && !isNaN(item));

  if (
    !array ||
    array.length === 0 ||
    typeof value !== "number" ||
    isNaN(value)
  ) {
    return null;
  }

  let sum = array.reduce((a, b) => a + b, 0);
  let mean = sum / array.length;

  let squareDiff = array.map((number) => Math.pow(number - mean, 2));
  let sumSquareDiff = squareDiff.reduce((a, b) => a + b, 0);
  let variance = sumSquareDiff / array.length;
  let stdDev = Math.sqrt(variance);
  if (stdDev === 0) {
    return 0;
  }

  let zScore = (value - mean) / stdDev;
  return zScore;
}

const AthleteOverviewSummaryCard = (props) => {
  const {
    athleteOverviewCardTitle,
    summaryType,
    summaryFor,
    isLoading,
    columns,
    rawDataState,
    fullRawDataState,
    maxMinAvg,
    processArray,
    groupByDate,
    overviewMetricData,
    filteringMethod,
    toggleCards,
    numberOfLatestSessions,
  } = props;

  const handleDataOpperation = (
    arr,
    operator,
    dataHandledTitle = "Not Set"
  ) => {
    if (operator === "min" && arr.length) {
      return arr.reduce((prev, curr) =>
        prev.total < curr.total ? prev : curr
      );
    }

    if (operator === "max" && arr.length) {
      return arr.reduce((prev, curr) =>
        prev.total > curr.total ? prev : curr
      );
    }

    if (operator === "avg" && arr.length) {
      const numObjects = arr.length;
      const summedObject = arr.reduce((acc, obj) => {
        Object.keys(obj).forEach((key) => {
          // Check if the value is a number and not null or undefined
          if (
            typeof obj[key] === "number" &&
            obj[key] !== null &&
            obj[key] !== undefined
          ) {
            acc[key] = (acc[key] || 0) + obj[key];
          }
        });
        return acc;
      }, {});

      const averagedObject = {};
      Object.keys(summedObject).forEach((key) => {
        averagedObject[key] = summedObject[key] / numObjects;
      });

      return averagedObject;
    }
  };

  const handleDominanceDataOpperation = (arr, operator) => {
    if (operator === "avg" && arr.length) {
      const numObjects = arr.length;
      const summedObject = arr.reduce((acc, obj) => {
        Object.keys(obj).forEach((key) => {
          // Check if the value is a number and not null or undefined
          if (
            typeof obj[key] === "number" &&
            obj[key] !== null &&
            obj[key] !== undefined
          ) {
            acc[key] = (acc[key] || 0) + obj[key];
          }
        });
        return acc;
      }, {});

      const averagedObject = {};
      Object.keys(summedObject).forEach((key) => {
        averagedObject[key] = summedObject[key] / numObjects;
      });

      return averagedObject;
    }

    if (operator === "min" && arr.length) {
      return arr.reduce((prev, curr) =>
        percentageDifferenceAbs(prev.leftValue , prev.rightValue)  < percentageDifferenceAbs(curr.leftValue , curr.rightValue) ? prev : curr
      );
    }

    if (operator === "max" && arr.length) {
      return arr.reduce((prev, curr) =>
        percentageDifferenceAbs(prev.leftValue , prev.rightValue)  > percentageDifferenceAbs(curr.leftValue , curr.rightValue) ? prev : curr
      );
    }
  }

 

  const handleDataFunctions = (
    arrayOfData,
    operator,
    targetKey,
    secondTargetKeys,
    returnedKeys,
    processingByDate = false
  ) => {
    if (processingByDate) {
      const processedData = groupByDate(
        arrayOfData.flatMap((item) => item)
      ).map((item) =>
        processArray(
          item,
          secondTargetKeys.map((key) => `rawMetrics.${targetKey}.${key}`), // Dynamically build keys
          operator,
          returnedKeys, // Adjust the output labels as needed
          processingByDate
        )
      );
      return processedData;
    }

    //have a look in here averages issues calculated
    if (!processingByDate) {
      const processedData = arrayOfData
        .flatMap((item) => item)
        .map((item) => [item])
        .map((item) =>
          processArray(
            item,
            secondTargetKeys.map((key) => `rawMetrics.${targetKey}.${key}`), // Dynamically build keys
            operator,
            returnedKeys, // Adjust the output labels as needed
            processingByDate
          )
        );

      return processedData;
    }
  };

  //gait data
  const walkData = Array.isArray(rawDataState.walkDataRaw)
    ? filteringMethod.latestSessions
      ? rawDataState.walkDataRaw.slice(0, numberOfLatestSessions)
      : rawDataState.walkDataRaw
    : [];
  const walkDataFull = Array.isArray(fullRawDataState.walkDataRaw)
    ? fullRawDataState.walkDataRaw
    : [];
  const jogData = Array.isArray(rawDataState.jogDataRaw)
    ? rawDataState.jogDataRaw
    : [];
  const jogDataFull = Array.isArray(fullRawDataState.jogDataRaw)
    ? fullRawDataState.jogDataRaw
    : [];
  const sprintData = Array.isArray(rawDataState.sprintDataRaw)
    ? filteringMethod.latestSessions
      ? rawDataState.sprintDataRaw.slice(0, numberOfLatestSessions)
      : rawDataState.sprintDataRaw
    : [];
  const sprintDataFull = Array.isArray(fullRawDataState.sprintDataRaw)
    ? fullRawDataState.sprintDataRaw
    : [];

  // Load -----------------------------------------------------------------------------------

  // filtered gait load data
  const gaitLoadDataProcessed = handleDataFunctions(
    [...walkData, ...jogData, ...sprintData],
    maxMinAvg,
    "loadResults",
    ["totalLoad", "leftLoad", "rightLoad"],
    ["total", "leftValue", "rightValue"],
    filteringMethod.dateRange || filteringMethod.presetRange
  );

  // filtered full gait load data
  const gaitLoadDataProcessedFull = handleDataFunctions(
    [...walkDataFull, ...jogDataFull, ...sprintDataFull],
    maxMinAvg,
    "loadResults",
    ["totalLoad", "leftLoad", "rightLoad"],
    ["total", "leftValue", "rightValue"],
    filteringMethod.dateRange || filteringMethod.presetRange
  );

  // Limb Dominance -----------------------------------------------------------------------------------

  //filtered gait limb dominance data
  const gaitLimbDominanceDataProcessed = handleDataFunctions(
    [...walkData, ...jogData, ...sprintData],
    maxMinAvg,
    "limbDominance",
    ["leftDominance", "rightDominance"],
    ["leftValue", "rightValue"]
  );

  //filtered full gait limb dominance data
  const gaitLimbDominanceDataProcessedFull = handleDataFunctions(
    [...walkDataFull, ...jogDataFull, ...sprintDataFull],
    maxMinAvg,
    "limbDominance",
    ["leftDominance", "rightDominance"],
    ["leftValue", "rightValue"]
  );

  //filtered sprint speed
  const sprintSpeedDataProcessed = handleDataFunctions(
    [...sprintData],
    maxMinAvg,
    "meanResults",
    [`gaitVelocity.${maxMinAvg}`],
    ["total"]
  );

  //filtered full sprint speed
  const sprintSpeedDataProcessedFull = handleDataFunctions(
    [...sprintDataFull],
    maxMinAvg,
    "meanResults",
    [`gaitVelocity.${maxMinAvg}`],
    ["total"]
  );

  //plyo data
  const doubleLegCountermovementJumpData = Array.isArray(
    rawDataState.doubleLegCountermovementJumpDataRaw
  )
    ? rawDataState.doubleLegCountermovementJumpDataRaw
    : [];
  const doubleLegCountermovementJumpDataFull = Array.isArray(
    fullRawDataState.doubleLegCountermovementJumpDataRaw
  )
    ? fullRawDataState.doubleLegCountermovementJumpDataRaw
    : [];
  const doubleLegDropJumpData = Array.isArray(
    rawDataState.doubleLegDropJumpDataRaw
  )
    ? rawDataState.doubleLegDropJumpDataRaw
    : [];
  const doubleLegDropJumpDataFull = Array.isArray(
    fullRawDataState.doubleLegDropJumpDataRaw
  )
    ? fullRawDataState.doubleLegDropJumpDataRaw
    : [];
  const doubleLegRepeatedHopsData = Array.isArray(
    rawDataState.doubleLegRepeatedHopsDataRaw
  )
    ? rawDataState.doubleLegRepeatedHopsDataRaw
    : [];
  const doubleLegRepeatedHopsDataFull = Array.isArray(
    fullRawDataState.doubleLegRepeatedHopsDataRaw
  )
    ? fullRawDataState.doubleLegRepeatedHopsDataRaw
    : [];
  const doubleLegSquatJumpData = Array.isArray(
    rawDataState.doubleLegSquatJumpDataRaw
  )
    ? rawDataState.doubleLegSquatJumpDataRaw
    : [];
  const doubleLegSquatJumpDataFull = Array.isArray(
    fullRawDataState.doubleLegSquatJumpDataRaw
  )
    ? fullRawDataState.doubleLegSquatJumpDataRaw
    : [];
  const singleLegCountermovementJumpData = Array.isArray(
    rawDataState.singleLegCountermovementJumpDataRaw
  )
    ? rawDataState.singleLegCountermovementJumpDataRaw
    : [];
  const singleLegCountermovementJumpDataFull = Array.isArray(
    fullRawDataState.singleLegCountermovementJumpDataRaw
  )
    ? fullRawDataState.singleLegCountermovementJumpDataRaw
    : [];
  const singleLegDropJumpDataData = Array.isArray(
    rawDataState.singleLegDropJumpDataRaw
  )
    ? rawDataState.singleLegDropJumpDataRaw
    : [];
  const singleLegDropJumpDataDataFull = Array.isArray(
    fullRawDataState.singleLegDropJumpDataRaw
  )
    ? fullRawDataState.singleLegDropJumpDataRaw
    : [];
  const singleLegRepeatedHopsData = Array.isArray(
    rawDataState.singleLegRepeatedHopsDataRaw
  )
    ? rawDataState.singleLegRepeatedHopsDataRaw
    : [];
  const singleLegRepeatedHopsDataFull = Array.isArray(
    fullRawDataState.singleLegRepeatedHopsDataRaw
  )
    ? fullRawDataState.singleLegRepeatedHopsDataRaw
    : [];
  const singleLegSquatJumpData = Array.isArray(
    rawDataState.singleLegSquatJumpDataRaw
  )
    ? rawDataState.singleLegSquatJumpDataRaw
    : [];
  const singleLegSquatJumpDataFull = Array.isArray(
    fullRawDataState.singleLegSquatJumpDataRaw
  )
    ? fullRawDataState.singleLegSquatJumpDataRaw
    : [];

  // Load -----------------------------------------------------------------------------------

  // filtered plyo load data
  const plyometricLoadDataProcessed = handleDataFunctions(
    [
      ...doubleLegCountermovementJumpData,
      ...doubleLegDropJumpData,
      ...doubleLegRepeatedHopsData,
      ...doubleLegSquatJumpData,
      ...singleLegCountermovementJumpData,
      ...singleLegDropJumpDataData,
      ...singleLegRepeatedHopsData,
      ...singleLegSquatJumpData,
    ],
    maxMinAvg,
    "loadResults",
    ["totalLoad", "leftLoad", "rightLoad"],
    ["total", "leftValue", "rightValue"],
    filteringMethod.dateRange || filteringMethod.presetRange
  );

  const plyometricLoadDataProcessedFull = handleDataFunctions(
    [
      ...doubleLegCountermovementJumpDataFull,
      ...doubleLegDropJumpDataFull,
      ...doubleLegRepeatedHopsDataFull,
      ...doubleLegSquatJumpDataFull,
      ...singleLegCountermovementJumpDataFull,
      ...singleLegDropJumpDataDataFull,
      ...singleLegRepeatedHopsDataFull,
      ...singleLegSquatJumpDataFull,
    ],
    maxMinAvg,
    "loadResults",
    ["totalLoad", "leftLoad", "rightLoad"],
    ["total", "leftValue", "rightValue"],
    filteringMethod.dateRange || filteringMethod.presetRange
  );

  // Limb Dominance  -----------------------------------------------------------------------------------
  const plyometricLimbDominanceDataProcessed = handleDataFunctions(
    [
      ...doubleLegCountermovementJumpData,
      ...doubleLegDropJumpData,
      ...doubleLegRepeatedHopsData,
      ...doubleLegSquatJumpData,
      ...singleLegCountermovementJumpData,
      ...singleLegDropJumpDataData,
      ...singleLegRepeatedHopsData,
      ...singleLegSquatJumpData,
    ],
    maxMinAvg,
    "limbDominance",
    ["leftDominance", "rightDominance"],
    ["leftValue", "rightValue"]
  );
  const plyometricLimbDominanceDataProcessedFull = handleDataFunctions(
    [
      ...doubleLegCountermovementJumpDataFull,
      ...doubleLegDropJumpDataFull,
      ...doubleLegRepeatedHopsDataFull,
      ...doubleLegSquatJumpDataFull,
      ...singleLegCountermovementJumpDataFull,
      ...singleLegDropJumpDataDataFull,
      ...singleLegRepeatedHopsDataFull,
      ...singleLegSquatJumpDataFull,
    ],
    maxMinAvg,
    "limbDominance",
    ["leftDominance", "rightDominance"],
    ["leftValue", "rightValue"]
  );

  // CMJ JumpHeight -----------------------------------------------------------------------------------------------
  const doubleLegCountermovementJumpDataProcessed = handleDataFunctions(
    [...doubleLegCountermovementJumpData],
    maxMinAvg,
    "combinedResults",
    [`jumpHeight.${maxMinAvg}`],
    ["total"]
  );

  const doubleLegCountermovementJumpDataProcessedFull = handleDataFunctions(
    [...doubleLegCountermovementJumpDataFull],
    maxMinAvg,
    "combinedResults",
    [`jumpHeight.${maxMinAvg}`],
    ["total"]
  );

  // DLRH rsi -----------------------------------------------------------------------------------------------
  const doubleLegRepeatedHopsDataProcessed = handleDataFunctions(
    [...doubleLegRepeatedHopsData],
    maxMinAvg,
    "combinedResults",
    [`RSI.${maxMinAvg}`],
    ["total"]
  );

  const doubleLegRepeatedHopsDataProcessedFull = handleDataFunctions(
    [...doubleLegRepeatedHopsDataFull],
    maxMinAvg,
    "combinedResults",
    [`RSI.${maxMinAvg}`],
    ["total"]
  );

  // DLDJ rsi --------------------------------------------------------------------------------------------------

  const doubleLegDropJumpDataProcessed = handleDataFunctions(
    [...doubleLegDropJumpData],
    maxMinAvg,
    "combinedResults",
    [`RSI.${maxMinAvg}`],
    ["total"]
  );

  const doubleLegDropJumpDataProcessedFull = handleDataFunctions(
    [...doubleLegDropJumpDataFull],
    maxMinAvg,
    "combinedResults",
    [`RSI.${maxMinAvg}`],
    ["total"]
  );

  // SLCMJ asym Jump height -------------------------------------------------------------------------------------------

  const singleLegCountermovementJumpDataProcessed = handleDataFunctions(
    [...singleLegCountermovementJumpData],
    maxMinAvg,
    "symmetryResults",
    [`jumpHeight.${maxMinAvg}`],
    ["total"]
  );

  const singleLegCountermovementJumpDataProcessedFull = handleDataFunctions(
    [...singleLegCountermovementJumpDataFull],
    maxMinAvg,
    "symmetryResults",
    [`jumpHeight.${maxMinAvg}`],
    ["total"]
  );

  //processing data for radar chart

  const radarChartData = [];

  //processing data addition

  const average = (array) => array.reduce((a, b) => a + b, 0) / array.length;
  const min = (array) =>
    array.reduce((acc, val) => (acc < val ? acc : val), Infinity);
  const max = (array) =>
    array.reduce((acc, val) => (acc > val ? acc : val), -Infinity);

  function processData({
    dataProcessed, // Array of data objects to process
    dataProcessedFull, // Full dataset for Z-score calculation
    maxMinAvg, // The type of calculation (min, max, avg)
    activity, // Default activity
    measuredUnit,
    subject,
    unit,
  }) {
    if (!dataProcessed || dataProcessed.length === 0) {
      return null; // If no data is provided, exit early
    }

    // Mapping data to get the 'total' value
    const values = dataProcessed.map((item) => item?.total);
    const fullData = dataProcessedFull.map((item) => item?.total);

    let processedData = 0;
    let processedMinTotal = 0;
    let processedAvgTotal = 0;
    let processedMaxTotal = 0;

    // Process data based on the chosen option (min, max, or avg)
    switch (maxMinAvg) {
      case "avg":
        processedData = average(values);

        processedMinTotal = min(fullData);
        processedAvgTotal = average(fullData);
        processedMaxTotal = max(fullData);
        break;
      case "min":
        processedData = min(values);

        processedMinTotal = min(fullData);
        processedAvgTotal = average(fullData);
        processedMaxTotal = max(fullData);
        break;
      case "max":
        processedData = max(values);

        processedMinTotal = min(fullData);
        processedAvgTotal = average(fullData);
        processedMaxTotal = max(fullData);
        break;
      default:
        throw new Error(
          "Invalid option for maxMinAvg. Choose 'min', 'max', or 'avg'."
        );
    }

    // Calculate Z-score for the processed data
    const athleteTotalValue = calculateZScore(processedData, fullData);
    const athleteTotal = processedData;
    const athleteTotalMinValue = calculateZScore(processedMinTotal, fullData);
    const athleteTotalMin = processedMinTotal;
    const athleteTotalMaxValue = calculateZScore(processedMaxTotal, fullData);
    const athleteTotalMax = processedMaxTotal;
    const athleteTotalAvgValue = calculateZScore(processedAvgTotal, fullData);
    const athleteTotalAvg = processedAvgTotal;

    // Create the final data object
    const dataObject = {
      activity,
      measuredUnit,
      subject,
      athleteTotalValue,
      athleteTotalMinValue,
      athleteTotalMaxValue,
      athleteTotalAvgValue,
      athleteTotal,
      athleteTotalMin,
      athleteTotalMax,
      athleteTotalAvg,
      athleteZscore: 0, // Assuming Z-score calculation modifies this later
      unit,
    };

    return dataObject;
  }

  //dlcmj radar process

  const dlcmjProcessed = processData({
    dataProcessed: doubleLegCountermovementJumpDataProcessed,
    dataProcessedFull: doubleLegCountermovementJumpDataProcessedFull,
    maxMinAvg: maxMinAvg,
    activity: "Double Leg Countermovement Jump - Jump Height (cm)",
    measuredUnit: "Jump Height",
    subject: "DLCMJ",
    unit: "cm",
  });

  if (dlcmjProcessed) {
    radarChartData.push(dlcmjProcessed);
  }

  //DLRH radar process

  const dlrhProcessed = processData({
    dataProcessed: doubleLegRepeatedHopsDataProcessed,
    dataProcessedFull: doubleLegRepeatedHopsDataProcessedFull,
    maxMinAvg: maxMinAvg,
    activity: "Double Leg Repeated Hops - RSI (rsi)",
    measuredUnit: "RSI",
    subject: "DLRH",
    unit: "rsi",
  });

  if (dlrhProcessed) {
    radarChartData.push(dlrhProcessed);
  }

  //DLDJ radar process

  const dldjProcessed = processData({
    dataProcessed: doubleLegDropJumpDataProcessed,
    dataProcessedFull: doubleLegDropJumpDataProcessedFull,
    maxMinAvg: maxMinAvg,
    activity: "Double Leg Drop Jump - RSI (rsi)",
    measuredUnit: "RSI",
    subject: "DLDJ",
    unit: "rsi",
  });

  if (dldjProcessed) {
    radarChartData.push(dldjProcessed);
  }

  // SLCMJ Asymm %  Jump Height

  const slcmjProcessed = processData({
    dataProcessed: singleLegCountermovementJumpDataProcessed,
    dataProcessedFull: singleLegCountermovementJumpDataProcessedFull,
    maxMinAvg: maxMinAvg,
    activity: "Single Leg Countermovement Jump - % (jump height)",
    measuredUnit: "%",
    subject: "SLCMJ",
    unit: "%",
  });

  if (slcmjProcessed) {
    radarChartData.push(slcmjProcessed);
  }

  // GAIT LIMB Dominance processed

  const gaitLimbDominanceDataProcessedPercentages =
    gaitLimbDominanceDataProcessed.map((item) => ({
      ...item,
      total: Number(percentageDifference(item?.leftValue, item?.rightValue)),
    }));
  const gaitLimbDominanceDataProcessedPercentagesFull =
    gaitLimbDominanceDataProcessedFull.map((item) => ({
      ...item,
      total: Number(percentageDifference(item?.leftValue, item?.rightValue)),
    }));

  const gaitLimbDominanceProcessed = processData({
    dataProcessed: gaitLimbDominanceDataProcessedPercentages,
    dataProcessedFull: gaitLimbDominanceDataProcessedPercentagesFull,
    maxMinAvg: maxMinAvg,
    activity: "Gait Limb Dominance",
    measuredUnit: "%",
    subject: "GLD",
    unit: "%",
  });

  if (gaitLimbDominanceProcessed) {
    radarChartData.push(gaitLimbDominanceProcessed);
  }

  //Load Data processed

  const loadDataProcessed = processData({
    dataProcessed: [...gaitLoadDataProcessed, ...plyometricLoadDataProcessed],
    dataProcessedFull: [
      ...gaitLoadDataProcessedFull,
      ...plyometricLoadDataProcessedFull,
    ],
    maxMinAvg: maxMinAvg,
    activity: "Load",
    measuredUnit: "",
    subject: "LD",
    unit: "a.u",
  });

  if (loadDataProcessed) {
    radarChartData.push(loadDataProcessed);
  }

  return !isLoading ? (
    <div
      className={`athlete_overview_summary_card`}
      style={{ minWidth: `${(100 / columns - 0.5)-.2}%` }}
    >
      <div className="athlete_overview_summary_headder">
        <h4>{athleteOverviewCardTitle}</h4>
      </div>
      <div
        className={`athlete_overview_summary_body ${
          !toggleCards ? "" : "overview_summary_card_close"
        }`}
      >
        {/*Gait Start---------------------------------------------------------------------------------------------*/}

        {summaryFor === "gait" && gaitLoadDataProcessed.length > 0 ? (
          <OverviewSummaryCard
            cardTitle={
              filteringMethod.dateRange || filteringMethod.presetRange
                ? "Load Data"
                : "Session Load"
            }
            maxMinAvg={maxMinAvg}
            cardType={"load"}
            filteredData={handleDataOpperation(
              gaitLoadDataProcessed,
              maxMinAvg
            )}
            fullData={handleDataOpperation(
              gaitLoadDataProcessedFull,
              maxMinAvg
            )}
            sessionFilter={
              filteringMethod.dateRange || filteringMethod.presetRange
            }
          />
        ) : null}

        {summaryFor === "gait" && gaitLimbDominanceDataProcessed.length > 0 ? (
          <OverviewSummaryCard
            cardTitle={"Limb Dominance"}
            maxMinAvg={maxMinAvg}
            cardType={"asymmetry"}
            filteredData={handleDominanceDataOpperation(
              gaitLimbDominanceDataProcessed,
              maxMinAvg
            )}
            fullData={handleDominanceDataOpperation(
              gaitLimbDominanceDataProcessedFull,
              maxMinAvg
            )}
          />
        ) : null}

        {summaryFor === "gait" && sprintSpeedDataProcessed.length > 0 ? (
          <OverviewSummaryCard
            cardTitle={"Speed (Sprint) (m/s)"}
            maxMinAvg={maxMinAvg}
            cardType={"progressComparisonBar"}
            filteredData={handleDataOpperation(
              sprintSpeedDataProcessed,
              maxMinAvg
            )}
            fullData={handleDataOpperation(
              sprintSpeedDataProcessedFull,
              maxMinAvg
            )}
          />
        ) : null}

        {/*Gait End---------------------------------------------------------------------------------------------*/}

        {/*Plyometrics Start---------------------------------------------------------------------------------------------*/}

        {summaryFor === "plyometrics" &&
        plyometricLoadDataProcessed.length > 0 ? (
          <OverviewSummaryCard
            cardTitle={
              filteringMethod.dateRange || filteringMethod.presetRange
                ? "Load Data"
                : "Session Load"
            }
            maxMinAvg={maxMinAvg}
            cardType={"load"}
            filteredData={handleDataOpperation(
              plyometricLoadDataProcessed,
              maxMinAvg
            )}
            fullData={handleDataOpperation(
              plyometricLoadDataProcessedFull,
              maxMinAvg
            )}
            sessionFilter={
              filteringMethod.dateRange || filteringMethod.presetRange
            }
          />
        ) : null}

        {summaryFor === "plyometrics" &&
        plyometricLimbDominanceDataProcessed.length > 0 ? (
          <OverviewSummaryCard
            cardTitle={"Limb Dominance"}
            maxMinAvg={maxMinAvg}
            cardType={"asymmetry"}
            filteredData={handleDominanceDataOpperation(
              plyometricLimbDominanceDataProcessed,
              maxMinAvg
            )}
            fullData={handleDominanceDataOpperation(
              plyometricLimbDominanceDataProcessedFull,
              maxMinAvg
            )}
          />
        ) : null}

        {summaryFor === "plyometrics" &&
        doubleLegCountermovementJumpDataProcessed.length > 0 ? (
          <OverviewSummaryCard
            cardTitle={"Height (CMJ) (cm)"}
            maxMinAvg={maxMinAvg}
            cardType={"progressComparisonBar"}
            filteredData={handleDataOpperation(
              doubleLegCountermovementJumpDataProcessed,
              maxMinAvg,
              "Height CMJ"
            )}
            fullData={handleDataOpperation(
              doubleLegCountermovementJumpDataProcessedFull,
              maxMinAvg,
              "Height CMJ Full"
            )}
          />
        ) : null}
        {/*Plyometrics End---------------------------------------------------------------------------------------------*/}

        {/* Radar chart star */}
        {summaryFor === "overview" ? (
          <div className="overview_radar_chart_containter">
            <OverivewRadarChart radarChartData={radarChartData} />
          </div>
        ) : null}
        {/* Radar chart end */}
      </div>
    </div>
  ) : (
    <div
      className="athlete_overview_summary_card shimmer"
      style={{ minWidth: `${100 / columns - 0.8}%` }}
    >
      <div className="athlete_overview_summary_headder"></div>
      <div className="athlete_overview_summary_body"></div>
    </div>
  );
};

export default AthleteOverviewSummaryCard;
